import getEnabledActions from '@tekion/tekion-base/utils/getEnabledActions';
import ACTIONS from '../constants/filterListItem.actions';
export var getRowActions = function getRowActions(isDefaultFilterRow, isDisabled, nonRemovable) {
  return getEnabledActions(ACTIONS, {
    isDefaultFilterRow: isDefaultFilterRow,
    isDisabled: isDisabled,
    nonRemovable: nonRemovable
  });
};